export enum ShippingAddressType {
  SAME_AS_BILLING = 'SAME_AS_BILLING',
  DIFFERENT_FROM_BILLING = 'DIFFERENT_FROM_BILLING',
  SAVED_ADDRESS = 'SAVED_ADDRESS'
}
